import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHtmlParser, {
    processNodes,
    convertNodeToElement,
    htmlparser2,
} from 'react-html-parser';

const ContentBoxStyled = styled.section`
    &.contentBox {
        display: block;
        width: 100%;

        & > header {
            font-size: 1.25rem;
            color: ${(props) => props.theme.colors.texts.capeCod};
            @media screen and (min-width: 768px) {
                font-size: 1.5rem;
            }
        }
        & > article {
            font: 1.125rem ${(props) => props.theme.fonts[1]};
            color: ${(props) => props.theme.colors.texts.shipGrey};
            margin-top: 13px;
            line-height: 42px;
            @media screen and (min-width: 768px) {
                font-size: 1.25rem;
            }
        }
    }
`;

export default function ContentBox(props) {
    const { hasHeadline, headlineText, wrapperClass, bodyText } = props;

    return (
        <ContentBoxStyled className={`contentBox ${wrapperClass}`}>
            {hasHeadline ? <header>{headlineText}</header> : ''}
            <article>{ReactHtmlParser(bodyText)}</article>
        </ContentBoxStyled>
    );
}

ContentBox.propTypes = {
    hasHeadline: PropTypes.bool,
    headlineText: PropTypes.string,
    bodyText: PropTypes.string.isRequired,
    wrapperClass: PropTypes.string,
};

ContentBox.defaultProps = {
    wrapperClass: '',
    hasHeadline: true,
};
